import React from 'react';
import { SearchableSelect } from './shared/SearchableSelect';
import { API_BASE_URL } from '../config/api';

/**
 * SearchableVehicleSelect - Async searchable dropdown for vehicle selection
 *
 * @param {Function} apiCall - Authenticated API call function
 * @param {number} selectedVehicleId - Currently selected vehicle ID
 * @param {Function} onSelectVehicle - Callback when vehicle is selected (vehicleId)
 * @param {number} storeId - Optional store filter
 * @param {boolean} required - Whether the field is required
 */
export function SearchableVehicleSelect({
  apiCall,
  selectedVehicleId,
  onSelectVehicle,
  storeId = null,
  required = true,
}) {
  const handleSearch = async (term) => {
    const params = new URLSearchParams({ search: term, limit: '20' });
    if (storeId) params.set('store_id', storeId);
    const res = await apiCall(`${API_BASE_URL}/vehicles?${params}`);
    // Exclude sold vehicles client-side
    return (res?.data || []).filter(v => v.status !== 'sold');
  };

  const handleFetchSelected = async (id) => {
    const res = await apiCall(`${API_BASE_URL}/vehicles/${id}`);
    return res?.data;
  };

  const getVehicleLabel = (v) =>
    `${v.year} ${v.make} ${v.model} - ${v.license_plate} (${v.license_plate_state || ''})`;

  return (
    <SearchableSelect
      selectedItemId={selectedVehicleId}
      onSelectItem={onSelectVehicle}
      onSearch={handleSearch}
      onFetchSelected={handleFetchSelected}
      getItemLabel={getVehicleLabel}
      renderItem={(v) => (
        <div style={{ fontWeight: 500 }}>
          {getVehicleLabel(v)}
        </div>
      )}
      placeholder="Search by make, model, year, license plate, or VIN..."
      label="Vehicle"
      required={required}
    />
  );
}

export default SearchableVehicleSelect;
